export const generateStructuredData = {
  homepage: () => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Kreatives",
    "description": "Nordic Creative Talent Platform",
    "url": window.location.origin,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${window.location.origin}/services/allservices?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  }),
  serviceList: (services = []) => ({
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Creative Services",
    "description": "Professional creative services offered by Nordic freelancers",
    "numberOfItems": services.length,
    "itemListElement": services.slice(0, 10).map((service, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Service",
        "name": service.title,
        "description": service.description,
        "provider": {
          "@type": "Person",
          "name": service.creative?.user?.first_name + ' ' + service.creative?.user?.last_name
        }
      }
    }))
  }),
  service: (service) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "name": service.title,
    "description": service.description,
    "provider": {
      "@type": "Person",
      "name": service.creative?.user?.first_name + ' ' + service.creative?.user?.last_name,
      "jobTitle": service.creative?.professional_title
    },
    "offers": {
      "@type": "Offer",
      "price": service.price,
      "priceCurrency": service.currency || "SEK",
      "availability": "https://schema.org/InStock"
    },
    "category": service.category,
    "areaServed": service.creative?.user?.country || "Nordic Countries"
  }),
  creative: (creative) => ({
    "@context": "https://schema.org",
    "@type": "Person",
    "name": creative.user?.first_name + ' ' + creative.user?.last_name,
    "jobTitle": creative.professional_title,
    "description": creative.bio,
    "image": creative.user?.profile_picture,
    "address": {
      "@type": "PostalAddress",
      "addressCountry": creative.user?.country,
      "addressLocality": creative.user?.city
    },
    "knowsAbout": creative.skills?.split(',') || [],
    "worksFor": {
      "@type": "Organization",
      "name": "Kreatives"
    }
  }),
  event: (event) => ({
    "@context": "https://schema.org",
    "@type": "Event",
    "name": event.title,
    "description": event.description,
    "startDate": event.date,
    "location": {
      "@type": "Place",
      "name": event.location,
      "address": event.address
    },
    "organizer": { "@type": "Organization", "name": "Kreatives" },
    "offers": event.ticketUrl ? { "@type": "Offer", "url": event.ticketUrl, "availability": "https://schema.org/InStock" } : undefined
  }),
  article: (article) => ({
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.description,
    "author": { "@type": "Person", "name": article.author },
    "publisher": {
      "@type": "Organization",
      "name": "Kreatives",
      "logo": { "@type": "ImageObject", "url": `${window.location.origin}/logo-kreativ-light.png` }
    },
    "datePublished": article.publishedTime,
    "dateModified": article.modifiedTime,
    "image": article.image
  }),
  faq: (faqs = []) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
    }))
  }),
  contact: () => ({
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Kreatives",
    "description": "Get in touch with the Kreatives team",
    "mainEntity": {
      "@type": "Organization",
      "name": "Kreatives",
      "url": window.location.origin,
      "email": "info@kreatives.app",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Hans Michelsensgatan 9",
        "addressLocality": "Malmö",
        "postalCode": "211 20",
        "addressCountry": "SE"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "url": `${window.location.origin}/contact`,
        "email": "info@kreatives.app",
        "availableLanguage": ["en", "se", "dk", "no", "fi", "is"]
      }
    }
  })
};
